import { render, staticRenderFns } from "./AccIncomeCap.vue?vue&type=template&id=252e72b8&scoped=true&"
import script from "./AccIncomeCap.vue?vue&type=script&lang=js&"
export * from "./AccIncomeCap.vue?vue&type=script&lang=js&"
import style0 from "./AccIncomeCap.vue?vue&type=style&index=0&id=252e72b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "252e72b8",
  null
  
)

export default component.exports